import { render, staticRenderFns } from "./EducationLevelOrderComponent.vue?vue&type=template&id=1bcea15b"
import script from "./EducationLevelOrderComponent.vue?vue&type=script&lang=js"
export * from "./EducationLevelOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports